function modal(id) {

  if (id.length) {
    let close = true;

    if ( id.attr('data-close') ) {
      close = false
    }

    id.bPopup({
        positionStyle: 'fixed',
        easing: 'easeOutBack',
        speed: 350,
        opacity: .5,
        appending: true,
        appendTo: '.website-wrapper',
        modalColor: '#3b4256',
        modalClose: close,
        onOpen: function() {
          let windowWidth = $('.workarea').width();
          setTimeout(function(){
            $("body").addClass('_modal-opened');
            $('.website-wrapper').css('max-width', windowWidth);

            const $scrollbar = $('.js-popup-scrollbar');
            if($scrollbar.length) {
              const ps = new CustomScrollbar($scrollbar);
            }

          }, 400);
        },
        onClose: function() {
          if (id.data('reload')) {
            window.location.reload();
          }
          // две открытых модвлки
          if($('.modal:visible').length) return;

          $("body").removeClass('_modal-opened');
          $('.website-wrapper').css('max-width', '');
        }
    });
  }

}
